import { useState } from "react";
import { useDispatch } from "react-redux";
import { AppDispatch } from "configureStore";
import { Button, InlineStack, Banner } from "@shopify/polaris";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { setDestroy, setIsModalxOpen } from "components/modalx/modalx.slice";
import { fetchFileDetails } from "containers/file/file.Slice";
import MultipleUserSelect from "features/multi-user-select/multi-user-select";
import { addAdditionalSignature } from "services/signature.service";
import { signerEditErrorKey } from "utils/signer-edit-errors";

interface ConfirmModalProps {
  fileId?: string;
  parentFileId?: string;
}

const ConfirmModal: React.FC<ConfirmModalProps> = ({
  fileId,
  parentFileId,
}) => {
  const dispatch: AppDispatch = useDispatch();
  const { companyId } = useParams();
  const { t } = useTranslation();
  const [successMessage, setSuccessMessage] = useState<string | null>(null);
  const [errMsg, setErrMsg] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [users, setUsers] = useState<any>([]);

  const handleAdditionalSignature = async () => {
    try {
      setIsLoading(true);
      if (!companyId) {
        setErrMsg("Missing company ID");
        return;
      }

      const payload = {
        fileId,
        users,
      };

      await addAdditionalSignature(companyId, payload);
      const detailsFileId = parentFileId || fileId;
      if (detailsFileId) {
        dispatch(fetchFileDetails({ fileId: detailsFileId, companyId }));
      }

      setSuccessMessage("ok");
      closeModal();
    } catch (e) {
      setErrMsg(signerEditErrorKey(e, "error"));
    } finally {
      setIsLoading(false);
    }
  };

  const closeModal = () => {
    dispatch(setIsModalxOpen(false));
    dispatch(setDestroy());
  };

  return (
    <>
      <div className="form-warnings">
        {errMsg && (
          <div>
            <Banner tone="critical">{t(errMsg)}</Banner>
          </div>
        )}
        {successMessage && (
          <div>
            <Banner tone="info">{t(successMessage)}</Banner>
          </div>
        )}
      </div>
      <h1 style={{ textAlign: "center" }}>
        {t("Are_you_sure_you_want_add_signers")}
      </h1>
      <div style={{ marginBottom: "10px" }}>
        <MultipleUserSelect
          onChange={setUsers}
          value={users}
          label={"select_user"}
        />
      </div>

      <InlineStack align="space-between">
        <Button
          onClick={handleAdditionalSignature}
          loading={isLoading}
          disabled={!users.length}
        >
          {t("Yes")}
        </Button>

        <Button onClick={closeModal}>{t("No")}</Button>
      </InlineStack>
    </>
  );
};

export default ConfirmModal;
